import React from 'react';
import './BjmseriesApplicati.css';
import BJMSeries from '../../../imgs/BJMSeriesApplicati.webp'; 

const BjmseriesApplicati = () => {
  return (
    <div className="Bjmseries-container"data-aos="flip-down" >
      <img src={BJMSeries} alt="Fitting Corrosion" className="Bjmseries-image" />
    </div>
  );
};

export default BjmseriesApplicati;
